module.exports = __webpack_public_path__ + "img/dutchpay.33b91a9c.png";